import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { styled, useStyleConfig, vui } from '../core';
import { cs, filterUndefined, isArray, isReactText } from '../utils';
import { ListProvider } from './context';
import ListDivider from './listDivider';
import ListHeading from './listHeading';
import ListIcon from './listIcon';
import ListItem from './listItem';
import ListText from './listText';
export const ListBase = styled.ulBox ``;
/** Displays a list of list link items and optional heading. Exposes some props to the children via context. */
export const List = vui((props, ref) => {
    const { children, className, heading, isInteractive, items, size, variant, ...rest } = props;
    const styles = useStyleConfig('List', props);
    const context = useMemo(() => filterUndefined({ isInteractive, size, variant }), [isInteractive, size, variant]);
    return (_jsx(ListProvider, { value: context, children: _jsxs(ListBase, { className: cs('vui-list', className), ref: ref, ...styles.container, ...rest, children: [isReactText(heading) ? _jsx(ListHeading, { text: heading }) : heading, children ??
                    (isArray(items)
                        ? items.map(({ key, ...props }, index) => _jsx(ListItem, { ...props }, key ?? index))
                        : items)] }) }));
});
List.Divider = ListDivider;
List.Heading = ListHeading;
List.Icon = ListIcon;
List.Item = ListItem;
List.Text = ListText;
List.displayName = 'List';
export default List;
